import { Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { deleteAlert } from "../../../components/alerts";
import DynamicTable from "../../../components/dynamicTable";
import AppHeader from "../../../components/header";
import AppLoader from "../../../components/loader";
import {
  deleteAgent,
  getAllAdmin,
  updateAgent,
} from "../../../services/AgentApi";
import {
  decryptPassword,
  handleApiCall,
  handleOpenSnackBar,
} from "../../../utils/helper";
import PasswordDialog from "../agents/PasswordDialog";
import AddEditAdminitratorDialog from "./AddEditAdministratorDialog";
import SearchTab from "./SearchTab";

const tableHeader = [
  "Admin Details",
  "User ID",
  "Password",
  "Designation",
  "Status",
  "Export",
  "Preview",
  "Actions",
];

const displayRows = [
  "agent_details",
  "agent_email",
  "agent_password",
  "designation",
  "custom_status",
  "custom_export",
  "can_preview",
  "actions",
];

const AdministratorPage = () => {
  const openDialogRef = useRef(null);
  const openPasswordDialogRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [allAdmin, setAllAdmin] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    handleFetchAllAdmin();
  }, []);

  const handleFetchAllAdmin = async () => {
    try {
      setIsLoading(true);
      const response = await getAllAdmin();
      if (response?.data.status === "success") {
        let data = response.data.data;
        setAllAdmin(data);
        setFilterData(data);
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterByNameIdEmail = (e) => {
    setSearchValue(e.target.value);
    const filtered = allAdmin.filter((itemm) => {
      return (
        itemm._id.toLowerCase().includes(e.target.value.toLowerCase()) ||
        itemm.username.toLowerCase().includes(e.target.value.toLowerCase()) ||
        itemm.email.toLowerCase().includes(e.target.value.toLowerCase())
      );
    });
    setFilterData(filtered);
  };

  // open add dialog

  const handleOpenAddDialog = () => {
    openDialogRef.current.isVisible({
      type: "add",
      data: null,
      getData: handleFetchAllAdmin,
    });
  };

  const handleEditData = (row) => {
    openDialogRef.current.isVisible({
      type: "edit",
      data: row,
      getData: handleFetchAllAdmin,
    });
  };

  const handleDeleteAgent = (row) => {
    deleteAlert(true, row._id, deleteAgent, handleFetchAllAdmin);
  };

  const handleShowPassword = (row) => {
    openPasswordDialogRef.current.isVisible({
      password: decryptPassword(row?.encrypted),
    });
  };

  const handleUpateAdminStatus = async (row, e, key) => {
    handleApiCall(
      row._id,
      updateAgent,
      { [key]: e },
      setIsLoading,
      () => {},
      handleFetchAllAdmin
    );
  };

  return (
    <AppHeader>
      <AppLoader isVisible={isLoading} />
      <Stack mb={3}>
        <Typography
          variant="primaryText"
          component={"h1"}
          fontSize={{ xs: "1.5rem", md: "2.125rem" }}
        >
          List Of All Admin
        </Typography>
        <Typography variant="secondaryText" component={"p"}>
          You can add and edit admins
        </Typography>
      </Stack>

      <SearchTab
        handleOpenAddDialog={handleOpenAddDialog}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        tableData={allAdmin}
        handleFilterData={handleFilterByNameIdEmail}
      />

      {allAdmin?.length > 0 && (
        <>
          {/* Dynamic Table */}
          <DynamicTable
            tableData={filterData || []}
            displayRows={displayRows}
            tableHeader={tableHeader}
            showDelete
            showEdit
            handleDelete={handleDeleteAgent}
            handleShowPassword={handleShowPassword}
            handleChangeCustomStatus={(row, e) =>
              handleUpateAdminStatus(row, e, "status")
            }
            handleChangeCustomExport={(row, e) =>
              handleUpateAdminStatus(row, e, "canExport")
            }
            handleEdit={handleEditData}
            handleAll
            handleAllowToPreview={(row, e) =>
              handleUpateAdminStatus(row, e, "canPreview")
            }
          />
        </>
      )}

      {/* Add edit dialog */}
      <AddEditAdminitratorDialog ref={openDialogRef} />
      <PasswordDialog ref={openPasswordDialogRef} />
    </AppHeader>
  );
};

export default AdministratorPage;
